<template>
<span>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-tabs :key="isSmallerScreen" :position="isSmallerScreen ? 'top' : 'left'" :value="active_step"
                 class="tabs-shadow-none" id="profile-tabs">

            <vs-tab :label="!isSmallerScreen ? 'RM Stock Snapshot Logs' : ''" icon="icon-archive" icon-pack="feather">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                  <raw-material-list/>
                </div>
            </vs-tab>

            <vs-tab :label="!isSmallerScreen ? 'RM Stock Adjustment Logs' : ''" icon="icon-box" icon-pack="feather">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                 <raw-material-all-batch-list/>
                </div>
            </vs-tab>

            <vs-tab :label="!isSmallerScreen ? 'FG Stock Snapshot Logs' : ''" icon="icon-archive" icon-pack="feather">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                  <formulation-list/>
                </div>
            </vs-tab>

            <vs-tab :label="!isSmallerScreen ? 'FG Stock Adjustment Logs' : ''" icon="icon-box" icon-pack="feather">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                 <finished-product-all-batch-list/>
                </div>
            </vs-tab>

            <vs-tab :label="!isSmallerScreen ? 'Sundry Stock Snapshot Logs' : ''" icon="icon-archive" icon-pack="feather">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                  <sundry-item-list/>
                </div>
            </vs-tab>

            <vs-tab :label="!isSmallerScreen ? 'Sundry Stock Adjustment Logs' : ''" icon="icon-box" icon-pack="feather">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                 <sundry-item-all-batch-list/>
                </div>
            </vs-tab>


        </vs-tabs>
      </div>
    </div>
  </span>
</template>

<script>
  import RawMaterialList from "./stock-adjust/raw-materials/RawMaterialList.vue";
  import RawMaterialAllBatchList from "./stock-adjust/raw-materials/RawMaterialAllBatchList.vue";
  import FinishedProductAllBatchList from "./stock-adjust/formulations/FinishedProductAllBatchList.vue";
  import FormulationList from "./stock-adjust/formulations/FormulationList.vue"
  import SundryItemAllBatchList from "./stock-adjust/sundry-items/SundryItemAllBatchList.vue";
  import SundryItemList from "./stock-adjust/sundry-items/SundryItemList.vue";

  export default {
    name: "LogHome",
    components: {
      RawMaterialList,
      RawMaterialAllBatchList,
      FinishedProductAllBatchList,
      FormulationList,
      SundryItemAllBatchList,
      SundryItemList
    },
    data() {
      return {
        active_step: this.$route.query.step ? this.$route.query.step : '0'
      }
    },
    computed: {
      isSmallerScreen() {
        return this.$store.state.windowWidth < 768
      }
    },
  }
</script>

<style scoped>

</style>
